
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/athletes",
      function () {
        return require("private-next-pages/athletes.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/athletes"])
      });
    }
  